import React from 'react';

function toDuration(milliseconds: number) {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    return {
        hours,
        minutes: minutes % 60,
        seconds: seconds % 60,
    };
}

export default ({ ms }: { ms: number }) => {
    const d = toDuration(ms);

    return (
        <>{`${d.minutes.toString().padStart(2, '0')}:${d.seconds.toString().padStart(2, '0')}`}</>
    );
};
